import moment from 'moment'
import axios from 'axios'
import firebase from 'firebase/app'
import 'firebase/auth'
import jwt from 'jsonwebtoken'
import ApiClient from '@/common/class/apiClient'

class AuthApiClient extends ApiClient {
  constructor () {
    super()
    this._cleanInstance = axios.create({ baseURL: this.baseURL })

    this._instance.interceptors.request.use(
      async config => {
        if (config.baseURL === this.baseURL && !config.headers.Authorization) {
          if (!this.token || moment().subtract(20, 'm').isAfter(moment(jwt.decode(this.token).iat, 'X'))) { // 超過時間
            this.token = await this._getToken()
          }
          config.headers.Authorization = this.token
        }

        return config
      },
      error => Promise.reject(error)
    )
  }

  removeAuthToken () {
    delete this.token
  }

  async _getToken () {
    const firebaseToken = await firebase.auth().currentUser.getIdToken(true)
    const { data: token } = await this._cleanInstance.post(this._authPath, null, {
      headers: { authorization: firebaseToken }
    })
    return token
  }
}

class StoreClient extends AuthApiClient {
  constructor () {
    super()
    this._authPath = '/getUserStoreAccessToken'
  }
}

class CashierClient extends AuthApiClient {
  constructor () {
    super()
    this._authPath = '/getUserCashierAccessToken'
  }
}

class MonitorClient extends AuthApiClient {
  constructor () {
    super()
    this._authPath = '/getUserMonitorAccessToken'
  }
}

export const storeClient = new StoreClient()
export const cashierClient = new CashierClient()
export const monitorClient = new MonitorClient()
